
import React, { useEffect, useState } from 'react';
import { Card, Divider, Button, Backdrop, CircularProgress } from '@mui/material';
import Modal from 'react-bootstrap/Modal';
import services from '../../services';
import { toast } from 'react-toastify';
import AddClient from './AddClient';
import AddUser from './AddUser';
import axios from 'axios';
import { FiEdit, FiLink } from "react-icons/fi";
import { GoUnlink } from "react-icons/go";
import { Tooltip } from 'react-tooltip';
import { GrSync } from "react-icons/gr";
import Resync from "./Re-syncAccount";
import UnlinkConfirmation from './UnlinkConfirmation';
import { styles } from './EmailAuthUser.styles';
const WhatsappAuth = ({ emailStatus, onClose }) => {
    const [allClient, setAllClient] = useState([]);
    const [authUrl, setAuthUrl] = useState('');
    const [step, setStep] = useState(1);
    const [authEmail, setAuthEmail] = useState('');
    const [selectedAccount, setSelectedAccount] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [clientId, setClientId] = useState(null);
    useEffect(() => {
        getClientEmail();
    }, []);
    const getClientEmail = async () => {
        setIsLoading(true);
        try {
            const { data } = await services.email.GET_ALL_CLIENT();
            setAllClient(data || []);
        } catch (e) {
            console.error(e);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        checkEmailUser();
    }, []);

    const [clientData, setClientData] = useState([]);
    const checkEmailUser = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/token/`, {
                headers: {
                    Authorization: `Bearer ${localStorage?.getItem('access_token')}`,
                },
            });

            setClientData(response?.data?.data);
            const findUnAuth = response?.data?.data?.find(({ token_status }) => token_status == 'token is authorized');
            if (findUnAuth?.client_id) {
                updateAuthEmail(findUnAuth?.client_id);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    const updateAuthEmail = async (client_id) => {
        try {
            const response =
                services.email.updateAuthEmail(client_id);
            setAuthUrl(response?.data?.authUrl);
        } catch (error) {
            console.error(error);
        }
    };

    const [authUrlData, setAuthUrlData] = useState([])
    const getAllAuthCredentials = async () => {
        try {
            const response = await services.email.GET_ALL_CREDENTIALS_EMAIL();
            setAuthUrlData(response?.data?.data)
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        getAllAuthCredentials()
    }, [])

    const handleStepChange = async (newStep, account = null) => {
        setIsLoading(true);
        try {
            if (newStep === 3 || newStep === 5) {
                await getAllAuthCredentials();
            }
            if (account) {
                setSelectedAccount(account);
                setAuthEmail(account.email);
            }
            setStep(newStep);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }

    function formatTimestampToDate(timestamp) {
        if (!timestamp || isNaN(Number(timestamp))) return "-";
        const date = new Date(Number(timestamp));
        const formatted = date.toLocaleString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });
        return formatted.replace(/am|pm/, (match) => match.toUpperCase());
    }

    const handleUpdateSyncmailStatus = async (item) => {
        setIsLoading(true);
        try {
            item.isMailSend = !item.isMailSend;
            const response = await services.email.UPDATE_EMAIL_SENDMAIL(item?.id, { isMailSend: item?.isMailSend })
            toast.success("Sync mail status updated successfully")
            await getClientEmail()
        } catch (error) {
            console.error(error)
            toast.error("Something went wrong")
        } finally {
            setIsLoading(false);
        }
    }
    const handleYes = () => {
        window.open(
            "https://myaccount.google.com/connections?gar=WzJd&continue=https%3A%2F%2Fmyaccount.google.com%2Fsecurity%3Fgar%3DWzJd%26hl%3Den_GB%26utm_source%3DOGB%26utm_medium%3Dact&hl=en_GB&utm_source=OGB&utm_medium=act",
            "_blank",
            "noopener,noreferrer"
        );
    }
    return (
        <>
            {/* Always keep Bootstrap Modal in the tree so it can animate closed
                and properly clean up its own backdrop before AppModal renders. */}
            <Modal show={step === 1 && !!emailStatus} onHide={onClose} centered size="xl">
                <Modal.Header closeButton style={styles.modalHeader}>
                    <Modal.Title>
                        <div style={styles.modalTitleRow}>
                            <div style={styles.titleIcon}>
                                <svg width="18" height="18" fill="none" stroke="#1a7d3e" strokeWidth="2" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                </svg>
                            </div>
                            <span style={styles.titleText}>Synced Gmail Accounts</span>
                            <span style={styles.countBadge}>{allClient.length}</span>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Divider />
                <Modal.Body style={styles.modalBody}>
                    {allClient && allClient.length > 0 ? (
                        <div style={styles.tableWrapper}>
                            <table style={styles.table}>
                                <thead>
                                    <tr style={styles.theadRow}>
                                        <th style={{ ...styles.th, width: '48px' }}>No.</th>
                                        <th style={styles.th}>Name</th>
                                        <th style={styles.th}>Email</th>
                                        <th style={styles.th}>Created</th>
                                        <th style={styles.th}>Last Updated</th>
                                        <th style={styles.th}>Expire Date</th>
                                        <th style={{ ...styles.th, textAlign: 'center' }}>Send Mail</th>
                                        <th style={{ ...styles.th, textAlign: 'center' }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {allClient.map((item, index) => {
                                        const isExpired = item?.expiration < Date.now();
                                        return (
                                            <tr
                                                key={item.id}
                                                style={isExpired ? styles.rowExpired : styles.row}
                                                onMouseEnter={e => { if (!isExpired) e.currentTarget.style.backgroundColor = '#f6fdf8'; }}
                                                onMouseLeave={e => { if (!isExpired) e.currentTarget.style.backgroundColor = '#fff'; }}
                                            >
                                                <td style={{ ...styles.td, color: '#9ca3af', fontWeight: '600' }}>{index + 1}</td>
                                                <td style={styles.td}>
                                                    <div style={styles.nameCell}>
                                                        <div style={styles.avatar}>{(item?.name || item?.email || '?').charAt(0).toUpperCase()}</div>
                                                        <span style={{ fontWeight: '500', color: '#111827' }}>{item?.name || '-'}</span>
                                                    </div>
                                                </td>
                                                <td style={styles.td}>
                                                    <span style={styles.emailChip}>{item?.email}</span>
                                                </td>
                                                <td style={{ ...styles.td, color: '#6b7280' }}>{item?.createdAt ? new Date(item.createdAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '-'}</td>
                                                <td style={{ ...styles.td, color: '#6b7280' }}>{item?.updatedAt ? new Date(item.updatedAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '-'}</td>
                                                <td style={styles.td}>
                                                    <span style={isExpired ? styles.expiredBadge : styles.activeBadge}>
                                                        {item?.expiration ? formatTimestampToDate(item.expiration) : '-'}
                                                    </span>
                                                </td>
                                                <td style={{ ...styles.td, textAlign: 'center' }}>
                                                    <div className="form-check form-switch" style={{ display: 'flex', justifyContent: 'center', margin: 0 }}>
                                                        <input
                                                            className="form-check-input"
                                                            style={{ height: '20px', width: '36px', cursor: 'pointer', accentColor: '#1a7d3e' }}
                                                            type="checkbox"
                                                            checked={item.isMailSend}
                                                            onChange={() => handleUpdateSyncmailStatus(item)}
                                                        />
                                                    </div>
                                                </td>
                                                <td style={{ ...styles.td, textAlign: 'center' }}>
                                                    <div style={styles.actionGroup}>
                                                        <button className="table-icon-edit" data-tooltip-id='my-tooltip' data-tooltip-content="Sync Account" onClick={() => { setClientId(item?.client_id); setStep(3); }}>
                                                            <FiLink />
                                                        </button>
                                                        <button className="table-icon-remove" data-tooltip-id='my-tooltip' data-tooltip-content="Unlink Account" onClick={() => handleStepChange(5, item)}>
                                                            <GoUnlink />
                                                        </button>
                                                        {item?.expiration >= Date.now() && (
                                                            <button
                                                                className="table-icon-remove"
                                                                style={{ backgroundColor: '#e0f4fb', color: '#0277bd', borderColor: 'rgba(2,119,189,0.2)' }}
                                                                data-tooltip-id="my-tooltip"
                                                                data-tooltip-content="Sync Old Mail"
                                                                onClick={() => handleStepChange(4, item)}
                                                            >
                                                                <GrSync />
                                                            </button>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div style={styles.emptyState}>
                            <svg width="40" height="40" fill="none" stroke="#d1d5db" strokeWidth="1.5" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                            </svg>
                            <p style={{ marginTop: '12px', color: '#9ca3af', fontSize: '14px' }}>No synced accounts found</p>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer style={styles.modalFooter}>
                    <button
                        style={styles.btnSecondary}
                        onMouseEnter={e => e.currentTarget.style.backgroundColor = '#e9fce8'}
                        onMouseLeave={e => e.currentTarget.style.backgroundColor = '#f0fdf4'}
                        onClick={() => handleStepChange(2)}
                    >
                        View
                    </button>
                    <button
                        style={styles.btnPrimary}
                        onMouseEnter={e => e.currentTarget.style.backgroundColor = '#1a6b2e'}
                        onMouseLeave={e => e.currentTarget.style.backgroundColor = '#1a7d3e'}
                        onClick={() => handleStepChange(3)}
                    >
                        + Sync New Gmail
                    </button>
                </Modal.Footer>
            </Modal>
            {step === 2 && (
                <AddClient
                    show={true}
                    onHide={() => setStep(1)}
                    setAuthUrl={setAuthUrl}
                    setStep={setStep}
                    authUrlData={authUrlData}
                    setIsLoading={setIsLoading}
                />
            )}
            {step === 3 && (
                <AddUser show={true} onHide={() => setStep(1)} authUrl={authUrl} setStep={setStep} updateAuthEmail={updateAuthEmail} setAuthUrlData={setAuthUrlData} authUrlData={authUrlData} setIsLoading={setIsLoading} clientId={clientId} />
            )}
            {step === 4 && (
                <Resync show={true} onHide={() => setStep(1)} authEmail={authEmail} setStep={setStep} updateAuthEmail={updateAuthEmail} setAuthUrlData={setAuthUrlData} authUrlData={authUrlData} setIsLoading={setIsLoading} />
            )}
            {step === 5 && (
                <UnlinkConfirmation
                    show={true}
                    onHide={() => {
                        setStep(1)
                        setSelectedAccount(null);
                    }}
                    handleYes={() => { handleYes() }}
                    authUrlData={authUrlData}
                    accountInfo={selectedAccount}
                    setIsLoading={setIsLoading}
                />
            )}
            <Tooltip id="my-tooltip" place='top' style={{ zIndex: 9999 }} />
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.modal + 1 })}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
};

export default WhatsappAuth;
